import background from "../../assets/images/team/team-bg.jpg";
import anna from "../../assets/images/team/team-new/anna.jpg";
import bas from "../../assets/images/team/team-new/bas.jpg";
import bruno from "../../assets/images/team/team-new/bruno.jpg";
import ceesjan from "../../assets/images/team/team-new/ceesjan.jpg";
import denick from "../../assets/images/team/team-new/denick.jpeg";
import edison from "../../assets/images/team/team-new/edison.jpg";
import guilherme from "../../assets/images/team/team-new/guilherme.jpg";
import jelmer from "../../assets/images/team/team-new/jelmer.jpg";
import jeroen from "../../assets/images/team/team-new/jeroen.jpg";
import joao from "../../assets/images/team/team-new/joao.jpg";
import joost from "../../assets/images/team/team-new/joost.jpg";
import julio from "../../assets/images/team/team-new/julio.jpg";
import karolien from "../../assets/images/team/team-new/karolien.jpg";
import marco from "../../assets/images/team/team-new/marco.jpg";
import maryna from "../../assets/images/team/team-new/maryna.jpg";
import mindaugas from "../../assets/images/team/team-new/mindaugas.jpg";
import saramago from "../../assets/images/team/team-new/saramago.jpg";
import vasco from "../../assets/images/team/team-new/vasco.jpg";
import wiebe from "../../assets/images/team/team-new/wiebe.jpg";
import ying from "../../assets/images/team/team-new/yinghao.jpg";
import yoshi from "../../assets/images/team/team-new/yoshi.jpg";
import diogo from "../../assets/images/team/team-new/diogo.jpg";
import jota from "../../assets/images/team/team-new/jota.jpg";
import teixeira from "../../assets/images/team/team-new/teixeira.jpg";
import grilo from "../../assets/images/team/team-new/grilo.jpg";
import mocho from "../../assets/images/team/team-new/mocho.jpg";

export default function TeamSection({ backgroundImg = "", className }) {
  return (
    <section
      className={`team-section-two bgs-cover ${
        backgroundImg === "none" ? "" : "text-white"
      } pt-115 rpt-95 pb-90 rpb-70 ${className || ""} `}
      style={
        backgroundImg
          ? { backgroundImage: `${backgroundImg}` }
          : { backgroundImage: `url(${background})` }
      }
    >
      <div className="container">
        <div className="section-title text-center mb-55">
          <span className="sub-title">Team Members</span>
          <h2>Meet our dedicated team!</h2>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={ying} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Ying Hao</h5>
                <span>CEO, Founder</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={karolien} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Karolien</h5>
                <span>Administration</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={ceesjan} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Ceesjan</h5>
                <span>Principal Systems Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={jelmer} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Jelmer</h5>
                <span>Human Resources</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={joao} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>João</h5>
                <span>Tech Lead</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={maryna} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Maryna</h5>
                <span>Scrum Manager</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={anna} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Anna</h5>
                <span>Product Owner</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={joost} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Joost</h5>
                <span>Product Owner</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={teixeira} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Pedro</h5>
                <span>Product Owner</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={wiebe} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Wiebe</h5>
                <span>Senior Software Engineer, Sysop</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={mindaugas} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Mindaugas</h5>
                <span>Senior Software Engineer</span>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={edison} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Edison</h5>
                <span>Software Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={bas} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Bas</h5>
                <span>Software Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={jeroen} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Jeroen</h5>
                <span>Software Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={marco} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Marco</h5>
                <span>Front-end Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={denick} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Denick</h5>
                <span>Software Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={saramago} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Saramago</h5>
                <span>Software Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={guilherme} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Guilherme</h5>
                <span>UI/UX Designer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={julio} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Júlio</h5>
                <span>Quality Assurance Tester</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={vasco} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Vasco</h5>
                <span>Front-end Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={bruno} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Bruno</h5>
                <span>Front-end Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={diogo} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Diogo</h5>
                <span>Software Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={jota} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Jota</h5>
                <span>Software Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={grilo} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Grilo</h5>
                <span>Software Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={mocho} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Mocho</h5>
                <span>Front-end Engineer</span>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-sm-6">
            <div className="team-member wow fadeInUp delay-0-2s style-two text-white">
              <div className="image">
                <img src={yoshi} alt="Team Member" />
              </div>
              <div className="member-designation">
                <h5>Yoshi</h5>
                <span>Barketing Executive</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
